import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_DATASTORE, FETCH_DATASTORES, DATASTORE_CREATE, DATASTORE_REMOVE, FETCH_ERROR } from './actions.type'
import { SET_DATASTORES, SET_DATASTORES_ERRORS, SET_DATASTORES_LOADING, SET_DATASTORE, SET_DATASTORE_ERRORS, SET_DATASTORE_LOADING } from './mutations.type'

const state = {
	dataStores: [],
	dataStoresErrors: [],
	dataStoresIsLoading: false,
	dataStore: null,
	dataStoreErrors: [],
	dataStoreIsLoading: false
}

const getters = {
	dataStores:state => key => {
		return state.dataStores.filter(x => x.name.toLowerCase().includes(key.toLowerCase()))
	},
	dataStoresErrors (state) {
		return state.dataStoresErrors
	},
	dataStoresIsLoading (state) {
		return state.dataStoresIsLoading
	},
	dataStore (state) {
		return state.dataStore
	},
	dataStoreErrors (state) {
		return state.dataStoreErrors
	},
	dataStoreIsLoading (state) {
		return state.dataStoreIsLoading
	}
}

const actions = {
	[FETCH_DATASTORES] (context) {
		context.commit(SET_DATASTORES_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/storages')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_DATASTORES, data)
					resolve(data)
				} else {
					context.commit(SET_DATASTORES_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_DATASTORES_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_DATASTORES_LOADING, false)
			})
		})
	},
	[FETCH_DATASTORE] (context, params) {
		context.commit(SET_DATASTORE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/storages/${params.workSpace}/${params.name}`, { id: params.id, workSpace: params.workSpace, name: params.name, href: params.href, type: params.type })
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_DATASTORE, data)
					resolve(data)
				} else {
					context.commit(SET_DATASTORE_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_DATASTORE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_DATASTORE_LOADING, false)
			})
		})
	},
	[DATASTORE_CREATE] (context, params) {
		context.commit(SET_DATASTORE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/storages/${params.nameW}`, params.data)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Хранилище подключено", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось подключить хранилище" })
				}	
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось подключить хранилище" })
				ErrorsService.setFetchError(SET_DATASTORE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_DATASTORE_LOADING, false)
			})
		})
	},
	[DATASTORE_REMOVE] (context, params) {
		context.commit(SET_DATASTORE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/storages/${params.workspace}/${params.name}/${params.type}`)
			.then(({data}) => {
				if (data) {
					state.dataStores = state.dataStores.filter(x => x.name != params.name && x.workSpace != params.workspace)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Хранилище удалено", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				ErrorsService.setFetchError(SET_DATASTORE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_DATASTORE_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_DATASTORES] (state, data) {
		state.dataStores = data
		state.dataStoresErrors = []
	},
	[SET_DATASTORES_ERRORS] (state, errors) {
		state.dataStores = []
		state.dataStoresErrors = errors
	},
	[SET_DATASTORES_LOADING] (state, status = true) {
		state.dataStoresIsLoading = status
	},
	[SET_DATASTORE] (state, data) {
		state.dataStore = data
		state.dataStoreErrors = []
	},
	[SET_DATASTORE_ERRORS] (state, errors) {
		state.dataStore = null
		state.dataStoreErrors = errors
	},
	[SET_DATASTORE_LOADING] (state, status = true) {
		state.dataStoreIsLoading = status
	}
}
export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/datastore.module.js